import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Form  } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem';
import SupplyChainActorDetails from "../partiesTab/supplyChainActorDetails";

 const SupplyChainActor=({invoiceId,merchandiseId})=> {
   

  const additionalSupplyChainList = useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.additionalSupplyChainActor || [])
  const itemDeleted = useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemDeleted) || '0'
  const isFormDisabled =  itemDeleted == '1' ? true : false 

  const {
    isLoading,
    AddItem,
    deleteItem,
    updateItem,
    saveItem,
    copyData
  } = useMultipleMerchandiseItem({tableName:"additionalSupplyChainActor",invoiceId,merchandiseId})

    const renderItem = useCallback(
      (item) => {
        return (
          <SupplyChainActorDetails
            key={item.id}
            item={item}
            isFormDisabled={isFormDisabled}
            updateData={updateItem}
            deleteData={deleteItem}
            saveData={saveItem}
            isItemTab={true}
            copyData={copyData}
          />
        )
      },
      [deleteItem,updateItem,saveItem,copyData,isFormDisabled]
    )

 
    return (
   
        <Form.Group className="float-container">
          <FormTitle title="ADDITIONAL SUPPLY CHAIN ACTOR" boxNumber="3/37"></FormTitle>
          <List renderItem={renderItem}
            dataSource={additionalSupplyChainList} 
          />
  
        {isLoading && <CustomLoader />}
        { additionalSupplyChainList?.length < 99 && <AddBtn
        disabled={(isFormDisabled || isLoading)}
        id={`supplyChain-${invoiceId}-${merchandiseId}`}
        onClick={AddItem}
        text='Add'
      />
        }
    
        </Form.Group>
     
    );
  }
  
  export default React.memo(SupplyChainActor)
